import moment from "moment";

//Sort function for snapshot dates
export const sortIt = (sortBy) => (a, b) =>
  a[sortBy] < b[sortBy] ? 1 : a[sortBy] > b[sortBy] ? -1 : 0;

//Function for comparing two objects
const isObject = (object) => {
  return object != null && typeof object === "object";
};

export const checkFilterData = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !checkFilterData(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }
  return true;
};

//Iterate object and array for expand and collapse button
export const formatValue = (key, val) => {
  if (typeof val === "object" && val !== null) {
    if (val instanceof Object && val instanceof Array) {
      return val.map((data) => {
        if (typeof data === "object" && data !== null) {
          return (
            JSON.stringify([data.filename]) ||
            JSON.stringify([data.name]) ||
            JSON.stringify([data.value]) ||
            ""
          );
        } else {
          return JSON.stringify([data]) || "";
        }
      });
    } else {
      if (key === "description") {
        if (val) {
          return val.content.map((data) => {
            if (data.content) {
              return data.content.map((dt) => {
                return dt.text || JSON.stringify(data, null, 2);
              });
            } else return JSON.stringify(data, null, 2) || "NULL";
          });
        } else return JSON.stringify(val, null, 2) || "NULL";
      }
      return (
        val.name || val.displayName || val.value || JSON.stringify(val, null, 2)
      );
    }
  } else if (val === null) {
    return "NULL";
  } else {
    return val;
  }
};

export const formatDate = (dt, gmtFlag) => {
  const newDt =
    dt !== "-"
      ? moment(dt).day(String) +
        " " +
        moment(dt, "YYYY-MM-DD hh:mm:ss").format("ll LTS")
      : "-";
  if (gmtFlag) return `${newDt} UTC`;
  else return `${newDt}`;
};

export const formatDateJobLog = (dt, gmtFlag) => {
  const newDt = dt !== "-" ? new Date(dt).toUTCString() : "-";
  if (dt !== "-")
    if (gmtFlag) return `${newDt}`;
    else return `${newDt.slice(0, -3)}`;
  else return newDt;
};

//Add issues and remove duplicates
export const setUniqueIssues = (arr, name, quickRestore) => {
  if (quickRestore) {
    if (arr.filter((item) => item.id === name.id).length === 0) {
      return arr.push(name);
    }
  } else {
    if (arr.filter((item) => item.issueId === name.issueId).length === 0) {
      return arr.push(name);
    }
  }
};

//Remove issues
export const issuesToRemove = (issueId, checkedIssues, quickRestore) => {
  if (quickRestore) {
    const findIndex = checkedIssues.findIndex((a) => a.id === issueId);
    findIndex !== -1 && checkedIssues.splice(findIndex, 1);
  } else {
    const findIndex = checkedIssues.findIndex((a) => a.issueId === issueId);
    findIndex !== -1 && checkedIssues.splice(findIndex, 1);
  }
};

//Issue/event type color
export const eventTypeBackColor = (eventType) => {
  switch (eventType.toLowerCase()) {
    case "in progress":
      return "rgb(227, 252, 239)";
    case "to do":
      return "rgb(222, 235, 255)";
    case "done":
      return "rgb(255, 235, 230)";
    default:
      return "rgb(235, 236, 240)";
  }
};

export const statusBackColor = (eventType) => {
  switch (eventType.toLowerCase()) {
    case "success":
      return "rgb(227, 252, 239)";
    case "running":
      return "rgb(222, 235, 255)";
    case "error":
      return "rgb(255, 235, 230)";
    default:
      return "rgb(235, 236, 240)";
  }
};

export const jobTypeBgColor = (eventType) => {
  switch (eventType.toLowerCase()) {
    case "backup":
      return "rgb(222, 235, 255)";
    case "restore":
      return "rgb(230, 252, 255)";
    case "issues":
      return "rgb(235, 236, 240)";
    case "configuration":
      return "rgb(255, 250, 230)";
    default:
      return "rgb(235, 236, 240)";
  }
};

export const issueTypeSelectBackColor = (issueType) => {
  switch (issueType.toLowerCase()) {
    case "bug":
      return "rgb(227, 252, 239)";
    case "epic":
      return "rgb(222, 235, 255)";
    case "story":
      return "rgb(255, 235, 230)";
    default:
      return "rgb(235, 236, 240)";
  }
};

//Sanitize table key
export const createKey = (input) => {
  return input ? input.replace(/^(the|a|an)/, "").replace(/\s/g, "") : input;
};

//Error Handler
export const errorHandler = (error) => {
  const { request, response } = error;
  if (response) {
    const status = response.status;
    const message = `Request failed with status code ${status}`;
    return {
      message,
      status,
    };
  } else if (request) {
    //request sent but no response received
    return {
      message: "server time out",
      status: 503,
    };
  } else {
    // Something happened in setting up the request that triggered an Error
    return { message: "opps! something went wrong while setting up request" };
  }
};

export const camelToTitle = (camelCase) => {
  return camelCase
    .replace(/([A-Z])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim();
};

export function formatSeconds(seconds) {
  // var date = new Date(1970,0,1);
  // date.setSeconds(seconds);
  return new Date(seconds * 1000).toISOString();
}

export function secondsToDhms(seconds) {
  seconds = Number(seconds);
  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor((seconds % (3600 * 24)) / 3600);
  var m = Math.floor((seconds % 3600) / 60);
  var s = Math.floor(seconds % 60);

  var dDisplay = d > 0 ? d + (d === 1 ? " day, " : " days, ") : "";
  var hDisplay = h > 0 ? h + (h === 1 ? " Hr, " : " Hrs, ") : "";
  var mDisplay = m > 0 ? m + (m === 1 ? " Min, " : " Mins, ") : "";
  var sDisplay = s > 0 ? s + (s === 1 ? " Sec" : " Secs") : "";
  return (dDisplay + hDisplay + mDisplay + sDisplay).replace(/,\s*$/, "");
}

export const sortAlhabetically = (array) => {
  try {
    return array.sort((a, b) =>
      a.label.toLowerCase().localeCompare(b.label.toLowerCase())
    );
  } catch (error) {
    return array;
  }
};
export const sortAlhabeticallyname = (array) => {
  try {
    return array.sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );
  } catch (error) {
    return array;
  }
};
export const sortAlhabeticallyproject = (array) => {
  try {
    return array.sort((a, b) =>
      a.projectName.toLowerCase().localeCompare(b.projectName.toLowerCase())
    );
  } catch (error) {
    return array;
  }
};
export function getEndPoints(title) {
  switch (title.toLowerCase()) {
    case "projects":
      return "/jira/projects";
    case "projectcategories":
      return "/secure/admin/projectcategories/ViewProjectCategories!default.jspa";
    case "dashboard":
      return "/jira/dashboards";
    case "filters":
      return "/jira/filters";
    case "issues":
      return "/issues";
    case "issuetypes":
      return "/jira/settings/issues/issue-types";
    case "issuetypeschemes":
      return "/jira/settings/issues/issue-type-schemes";
    case "subtasks":
      return "/secure/admin/subtasks/ManageSubTasks.jspa";
    case "workflows":
      return "/jira/settings/issues/workflows";
    case "workflowschemes":
      return "/secure/admin/ViewWorkflowSchemes.jspa";
    case "screens":
      return "/jira/settings/issues/screens";
    case "screenschemes":
      return "/jira/settings/issues/screen-schemes";
    case "issuetypescreenschemes":
      return "/jira/settings/issues/issue-type-screen-schemes";
    case "customfields":
      return "/secure/admin/ViewCustomFields.jspa";
    case "fields":
      return "/secure/admin/ViewCustomFields.jspa";
    case "fieldconfigurations":
      return "/secure/admin/ViewFieldLayouts.jspa";
    case "statuses":
      return "/secure/admin/ViewStatuses.jspa";
    case "resolutions":
      return "/secure/admin/ViewResolutions.jspa";
    case "priorities":
      return "/secure/admin/ViewPriorities.jspa";
    case "issuesecurityschemes":
      return "/secure/admin/ViewIssueSecuritySchemes.jspa";
    case "notificationschemes":
      return "/secure/admin/ViewNotificationSchemes.jspa";
    case "permissionschemes":
      return "/secure/admin/ViewPermissionSchemes.jspa";
    case "issuelinking":
      return "/secure/admin/ViewLinkTypes!default.jspa";
    case "projectroles":
      return "/secure/project/ViewProjectRoles.jspa";
    case "permissiontypes":
      return "/secure/admin/GlobalPermissions!default.jspa";
    default:
      return "/";
  }
}
